const pt = {
    FILTERS_BUTTON_DROPDOWN: 'Orden Ascendente',
    DASHBOARD_USERS_FILTER_ALPHABETICAL: 'Alphabetical',
    DASHBOARD_USERS_FILTER_NUMERIC: 'Numeric',
    DASHBOARD_USERS_FILTER_DATE: 'Date',
    ATTRIBUTES_PLACEHOLDER_SEARCH: 'Buscar atributo de usuario',
    DASHBOARD_USERS_FILTER_ORDER: 'Ordenar por',
    SAVE_FILTERS_BUTTON_CANCEL: 'Cancel',
    SAVE_FILTERS_BUTTON_SAVE: 'Guardar'
};
const localePt = pt;
export default localePt;
